
export const TERRAINS: string[] = ['Groomed Runs', 'Carving', 'Moguls', 'Tree Runs', 'Powder', 'Park']
export const LANGUAGES: string[] = ['Afrikaans','Albanian','Amharic','Arabic','Armenian','Azerbaijani','Basque','Belarusian','Bengali','Bosnian','Bulgarian','Burmese','Catalan','Cebuano','Chichewa','Chinese','Corsican','Croatian','Czech','Danish','Dutch','English','Esperanto','Estonian','Finnish','French','Frisian','Georgian','German','Greek','Hausa','Hawaiian','Hebrew','Hindi','Hmong','Hungarian','Icelandic','Indonesian','Italian','Japanese','Javanese','Kannada','Kazakh','Khmer','Kinyarwanda','Kirundi','Korean','Kyrgyz','Lao','Latvian','Lithuanian','Luxembourgish','Macedonian','Malagasy','Malay','Malayalam','Maltese','Maori','Marathi','Mongolian','Nepali','Norwegian','Oriya','Pashto','Persian','Polish','Portuguese','Punjabi','Romanian','Russian','Serbian','Sinhala','Slovak','Slovenian','Somali','Spanish','Sundanese','Swahili','Swedish','Tagalog','Tajik','Tamil','Tatar','Telugu','Thai','Tibetan','Tigrinya','Tongan','Turkish','Turkmen','Uighur','Ukrainian','Urdu','Uzbek','Vietnamese','Welsh','Xhosa','Yiddish','Yoruba','Zulu']
// export const INSTRUCTOR_SCHOOLS: string[] = ['School Number 1', 'Example School', 'Skiing School', 'Other Ski School', 'School For Skiing']
export const INSTRUCTOR_SCHOOLS: string[] = ['None','Coronet Peak','The Remarkables','Cardrona','Treble Cone','MT. Hutt','Whakapapa','Turoa','MT. Dobson','Ohau','Porters','Rainbow','Temple Basin','MT. Lyford']

export enum ACTIVITY_TYPE {
	SKIING = 'Skiing',
	SNOWBOARDING = 'Snowboarding'
}

export const INSTRUCTOR_GENDERS = ['Male', 'Female', 'Non-Binary', 'Other']

export const ACTIVITY_OPTIONS = [ACTIVITY_TYPE.SKIING, ACTIVITY_TYPE.SNOWBOARDING, 'Both']

export enum SEARCH_PARAMS {
	ACTIVITY = 'ac',
	GROUP_SIZE = 'gs',
	INSTRUCTOR_LEVEL = 'il',
	SKI_SCHOOL = 'ssId',
	NAME = 'name',
	LANGUAGE = 'la',
	GENDER = 'ge',
	RATING = 'ra',
	AGE = 'ag',
	TERRAIN = 'te',
	PRICE_RANGE = 'pr'
}
